module.exports = __webpack_public_path__ + "img/3.d3e354e3.jpg";